import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  DataGrid,
  GridToolbarQuickFilter,
  GridLinkOperator,
  gridClasses,
} from "@mui/x-data-grid";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import GridItemLogin from "components/Grid/GridItemLogin.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeadertab.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import Config from "conFig.js";
import styles from "assets/jss/material-dashboard-react/components/headerLinksStyle.js";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import CloseIcon from "@mui/icons-material/Close";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";
import DoneIcon from "@mui/icons-material/Done";
import DangerousIcon from "@mui/icons-material/Dangerous";
import Box from "@mui/material/Box";

const useStyles = makeStyles(styles);
const datagridSx = {
  [`& .${gridClasses.cell}`]: {
    py: 1,
  },
  [`& .center`]: {
    justifyContent: "center !important",
  },
  borderRadius: 2,
  "& .MuiDataGrid-main": { borderRadius: 2 },
  "& .MuiDataGrid-virtualScrollerRenderZone": {
    "& .MuiDataGrid-row": {
      "&:nth-of-type(2n)": { backgroundColor: "rgba(235, 235, 235, .7)" },
    },
  },
  "& .MuiDataGrid-columnHeaders": {
    backgroundColor: "rgba(0,0,255,0.6)",
    color: "rgb(255 255 255)",
    fontSize: 16,
  },
  "& .MuiInputBase-root": {
    height: "25px",
  },
};
export default function Role() {
  const classes = useStyles();
  const token = localStorage.getItem("token");
  const [roles, setroles] = React.useState([]);
  const [openthemroles, setOpenroles] = React.useState(false);
  const [openwarning, setOpenWarning] = React.useState(false);
  const [openxoarole, setOpenxoarole] = React.useState(false);
  const [warrningContent, setWarrningContent] = React.useState("");
  const [deleteId, setDeleteId] = React.useState("");
  const [pageSize, setPageSize] = React.useState(50);

  const [alert, setAlert] = React.useState(false);
  const [message, setMessage] = React.useState("");
  const [icon, setIcon] = React.useState(AddAlert);
  const [color, setColor] = React.useState("warning");

  const [addObj, setAddObj] = React.useState({});
  const quickSearchToolbar = () => {
    return (
      <Box
        sx={{
          p: 0.5,
          pb: 0,
        }}
      >
        <GridToolbarQuickFilter
          quickFilterParser={(searchInput: string) =>
            searchInput
              .split(",")
              .map((value) => value.trim())
              .filter((value) => value !== "")
          }
          placeholder="Tìm kiếm"
        />
      </Box>
    );
  };
  // Xử lú API
  const getroles = () => {
    var url = Config.backend + "/api/roles/roles";
    fetch(url)
      .then((res) => res.json())
      .then((data) => {
        setroles(data);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const themRole = () => {
    var url = Config.backend + "/api/roles/themRole";
    fetch(url, {
      method: "POST",
      headers: {
        Accept: "application/json, text/plain",
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify({
        rolE_ID: addObj.rolE_ID,
        rolE_NAME: addObj.rolE_NAME,
        ghI_CHU: addObj.ghI_CHU,
      }),
    })
      .then((response) => {
        if (response.ok) {
          return response;
        }
        throw new Error("Something went wrong");
      })
      .then(() => {
        handleClose();
        getroles();
        showNotification("Thêm role thành công", DoneIcon, "success");
      })
      .catch((error) => {
        handleClose();
        console.error("Error fetching data: ", error);
        showNotification("Thêm role thất bại", DangerousIcon, "danger");
      });
  };

  const deleteRole = () => {
    if (deleteId === "") {
      setWarrningContent("Bạn chưa chọn roles để xóa !!!");
      setOpenWarning(true);
    } else {
      let url = Config.backend + "/api/roles/xoa_role?rolE_ID=" + deleteId;
      fetch(url, {
        method: "DELETE",
        headers: {
          Accept: "application/json, text/plain",
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: "Bearer " + token,
        },
      })
        .then((response) => {
          if (response.ok) {
            return response;
          }
          throw new Error("Something went wrong");
        })
        .then(() => {
          handlexoaClose();
          getroles();
          showNotification("Xóa role thành công", DoneIcon, "success");
        })
        .catch((error) => {
          handlexoaClose();
          console.error("Error fetching data: ", error);
          showNotification("Xóa role thất bại", DangerousIcon, "danger");
        });
    }
  };

  const rolescolumn = [
    {
      field: "rolE_ID",
      headerName: "ROLE ID",
      width: 300,
      headerAlign: "center",
      cellClassName: "center",
    },
    {
      field: "rolE_NAME",
      headerName: "ROLE NAME",
      width: 300,
      headerAlign: "center",
    },
    {
      field: "ghI_CHU",
      headerName: "Ghi Chú",
      width: 300,
      headerAlign: "center",
    },
  ];

  const openThemLoaiRole = () => {
    setOpenroles(true);
  };
  const openXoaRole = () => {
    if (deleteId === "") {
      setWarrningContent("Bạn chưa chọn role cần xóa !!!");
      setOpenWarning(true);
    } else {
      setOpenxoarole(true);
    }
  };

  const handleClose = () => setOpenroles(false);
  const handleCloseWarning = () => setOpenWarning(false);
  const handlexoaClose = () => {
    setOpenxoarole(false);
    setDeleteId("");
  };

  const showNotification = (ms, icon, color) => {
    setAlert(true);
    setMessage(ms);
    setIcon(icon);
    setColor(color);
    setTimeout(function () {
      setAlert(false);
    }, 3000);
  };

  React.useEffect(() => {
    getroles();
  }, []);
  return (
    <GridContainer>
      <GridItem
        xs={12}
        sm={10}
        md={12}
        style={{ marginTop: 5, marginBottom: 10 }}
      >
        <Button
          color="primary"
          variant="contained"
          onClick={openThemLoaiRole}
          style={{ height: 25 }}
        >
          Thêm mới
        </Button>
        <Button
          variant="contained"
          onClick={openXoaRole}
          style={{
            marginLeft: 10,
            color: "#fff",
            backgroundColor: "#BB2124",
            height: 25,
          }}
        >
          Xóa
        </Button>
      </GridItem>
      <GridItem xs={12} sm={10} md={12}>
        <div style={{ height: 500, width: "100%" }}>
          <DataGrid
            getRowId={(row) => row.rolE_ID}
            rows={roles}
            columns={rolescolumn}
            checkboxSelection={false}
            onRowClick={(params, event) => {
              setDeleteId(params.row.rolE_ID);
              event.defaultMuiPrevented = true;
            }}
            getRowHeight={() => "auto"}
            headerHeight={35}
            sx={datagridSx}
            pageSize={pageSize}
            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
            rowsPerPageOptions={[20, 50, 100]}
            pagination
            initialState={{
              filter: {
                filterModel: {
                  items: [],
                  quickFilterLogicOperator: GridLinkOperator.Or,
                },
              },
            }}
            components={{ Toolbar: quickSearchToolbar }}
          />
        </div>
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color={color}
            icon={icon}
            message={message}
            open={alert}
            closeNotification={() => setAlert(false)}
            close
          />
        </GridItem>
      </GridItem>

      {/* S--Thêm  roles--S */}
      <Modal
        open={openthemroles}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div>
          <GridContainer>
            <GridItemLogin xs={12} sm={12} md={3}></GridItemLogin>
            <GridItemLogin xs={12} sm={12} md={6}>
              <Card>
                <CardHeader color="primary" style={{ height: 10 }}>
                  <h6
                    className={classes.cardTitleWhite}
                    style={{ marginTop: "-5px" }}
                  >
                    Thêm roles
                  </h6>
                </CardHeader>
                <CardBody style={{ borderBottom: "1px solid #bbb" }}>
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={6}>
                      <FormControl style={{ width: "100%", marginTop: "20px" }}>
                        <TextField
                          label="Role ID"
                          variant="outlined"
                          size="small"
                          onChange={(event) => {
                            const obj = {
                              ...addObj,
                              rolE_ID: event.target.value,
                            };
                            setAddObj(obj);
                          }}
                        />
                      </FormControl>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={6}>
                      <FormControl style={{ width: "100%", marginTop: "20px" }}>
                        <TextField
                          label="Role Name"
                          variant="outlined"
                          size="small"
                          onChange={(event) => {
                            const obj = {
                              ...addObj,
                              rolE_NAME: event.target.value,
                            };
                            setAddObj(obj);
                          }}
                        />
                      </FormControl>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={12}>
                      <FormControl style={{ width: "100%", marginTop: "20px" }}>
                        <TextField
                          label="Ghi chú"
                          variant="outlined"
                          size="small"
                          multiline
                          onChange={(event) => {
                            const obj = {
                              ...addObj,
                              ghI_CHU: event.target.value,
                            };
                            setAddObj(obj);
                          }}
                        />
                      </FormControl>
                    </GridItem>
                  </GridContainer>
                </CardBody>
                <CardFooter>
                  <GridItem xs={12} sm={12} md={6}></GridItem>
                  <GridItem
                    xs={12}
                    sm={12}
                    md={6}
                    style={{ textAlign: "right" }}
                  >
                    <Button
                      color="primary"
                      variant="contained"
                      onClick={themRole}
                    >
                      Thêm
                    </Button>
                    <Button
                      variant="contained"
                      onClick={handleClose}
                      style={{
                        marginLeft: 10,
                        color: "#fff",
                        backgroundColor: "#f7941d",
                      }}
                    >
                      Trở về
                    </Button>
                  </GridItem>
                </CardFooter>
              </Card>
            </GridItemLogin>
            <GridItemLogin xs={12} sm={12} md={3}></GridItemLogin>
          </GridContainer>
        </div>
      </Modal>
      {/* E--Thêm  roles--E */}

      {/* S--Xóa  role--S */}
      <Modal
        open={openxoarole}
        onClose={handlexoaClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div>
          <GridContainer>
            <GridItemLogin xs={12} sm={12} md={3}></GridItemLogin>
            <GridItemLogin xs={12} sm={12} md={6}>
              <Card>
                <CardHeader color="primary" style={{ height: 10 }}>
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={5}>
                      <FormControl style={{ width: "100%", marginTop: "15px" }}>
                        <h6
                          className={classes.cardTitleWhite}
                          style={{ marginTop: "-5px" }}
                        >
                          Xóa role
                        </h6>
                      </FormControl>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={6}></GridItem>
                    <GridItem xs={12} sm={12} md={1}>
                      <FormControl style={{ width: "100%", marginTop: "1px" }}>
                        <CloseIcon onClick={handlexoaClose} />
                      </FormControl>
                    </GridItem>
                  </GridContainer>
                </CardHeader>
                <CardBody style={{ borderBottom: "1px solid #bbb" }}>
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                      <h5>
                        Bạn có muốn xóa role <strong>{deleteId}</strong> ?
                      </h5>
                    </GridItem>
                  </GridContainer>
                </CardBody>
                <CardFooter>
                  <GridItem xs={12} sm={12} md={6}></GridItem>
                  <GridItem
                    xs={12}
                    sm={12}
                    md={6}
                    style={{ textAlign: "right" }}
                  >
                    <Button
                      variant="contained"
                      onClick={deleteRole}
                      style={{ color: "#fff", backgroundColor: "#BB2124" }}
                    >
                      Xóa
                    </Button>
                    <Button
                      variant="contained"
                      onClick={handlexoaClose}
                      style={{
                        marginLeft: 10,
                        color: "#fff",
                        backgroundColor: "#f7941d",
                      }}
                    >
                      Trở về
                    </Button>
                  </GridItem>
                </CardFooter>
              </Card>
            </GridItemLogin>
            <GridItemLogin xs={12} sm={12} md={3}></GridItemLogin>
          </GridContainer>
        </div>
      </Modal>
      {/* E--Xóa  role--E */}

      {/* S--Warning modal--S */}
      <Modal
        open={openwarning}
        onClose={handleCloseWarning}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div>
          <GridContainer>
            <GridItemLogin xs={12} sm={12} md={3}></GridItemLogin>
            <GridItemLogin xs={12} sm={12} md={6}>
              <Card>
                <CardHeader color="primary" style={{ height: 10 }}>
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={5}>
                      <FormControl style={{ width: "100%", marginTop: "15px" }}>
                        <h6
                          className={classes.cardTitleWhite}
                          style={{ marginTop: "-5px" }}
                        >
                          Thông báo
                        </h6>
                      </FormControl>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={6}></GridItem>
                    <GridItem xs={12} sm={12} md={1}>
                      <FormControl style={{ width: "100%", marginTop: "1px" }}>
                        <CloseIcon onClick={handleCloseWarning} />
                      </FormControl>
                    </GridItem>
                  </GridContainer>
                </CardHeader>
                <CardBody style={{ borderBottom: "1px solid #bbb" }}>
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                      <h5>{warrningContent}</h5>
                    </GridItem>
                  </GridContainer>
                </CardBody>
                <CardFooter>
                  <GridItem xs={12} sm={12} md={6}></GridItem>
                  <GridItem
                    xs={12}
                    sm={12}
                    md={6}
                    style={{ textAlign: "right" }}
                  >
                    <Button
                      variant="contained"
                      onClick={handleCloseWarning}
                      style={{
                        marginLeft: 10,
                        color: "#fff",
                        backgroundColor: "#f7941d",
                      }}
                    >
                      Trở về
                    </Button>
                  </GridItem>
                </CardFooter>
              </Card>
            </GridItemLogin>
            <GridItemLogin xs={12} sm={12} md={3}></GridItemLogin>
          </GridContainer>
        </div>
      </Modal>
    </GridContainer>
  );
}
